import {
  Box,
  Heading,
  Image,
  Stack,
  Text,
} from '@chakra-ui/react';
import * as React from 'react';

import { IGroupSearch } from '@/client/legacy-shared-modules/search/search-types';
import { CustomHighlight } from '@/components/CustomHighlight';
import { CustomSnippet } from '@/components/CustomSnippet';
import { ImageFallback } from '@/imports/ui/chakra/components/ImageFallback';

import { ListItemHit } from './ListItemHit';

export type GroupHitsVariant = 'default';

export const GroupHit = (
  hit: IGroupSearch,
  variant: GroupHitsVariant = 'default',
  disableHighlight = false
): React.ReactNode => {
  const memberCountLabel =
    hit.totalMembers === 1 ? '1 Member' : `${hit.totalMembers} Members`;

  return (
    <ListItemHit key={hit.objectID} to={`/community/groups/${hit.objectID}/activity`}>
      <Stack direction="row" spacing="4">
        <Box
          boxSize={20}
          p="1"
          boxShadow="base"
          borderRadius="lg"
          position="relative"
          bg="white"
          flexShrink="0"
        >
          {hit.profilePictureUrl ? (
            <Image src={hit.profilePictureUrl || undefined} alt="group" />
          ) : (
            <ImageFallback aspectRatio="1" borderRadius="lg" bg="gray.200" />
          )}
        </Box>
        <Stack spacing="1">
          <Heading size="sm">
            {disableHighlight ? (
              hit.name
            ) : (
              <CustomHighlight attribute="name" hit={hit} />
            )}
          </Heading>
          <Text color="gray.600" textStyle="compact">
            {memberCountLabel}
          </Text>
          {hit.description ? (
            disableHighlight ? (
              <Text noOfLines={2} color="gray.700">
                {hit.description}
              </Text>
            ) : (
              <CustomSnippet attribute="description" hit={hit} />
            )
          ) : null}
        </Stack>
      </Stack>
    </ListItemHit>
  );
};
